interface ErrorMessageProps {
  error?: Error | null;
  message?: string;
  retry?: () => void;
}

export const ErrorMessage = ({ error, message, retry }: ErrorMessageProps) => {
  const displayMessage = message || error?.message || 'An error occurred';

  return (
    <div className="error">
      <p>{displayMessage}</p>
      {retry && (
        <button className="load-more-button" onClick={retry}>
          Retry
        </button>
      )}
    </div>
  );
};

